import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { getText } from "../../utils/languageUtils";

const QuizQuestionSection = ({
    question,
    handleNextClick,
    handlePreviousClick,
    selectedOptions,
    nextBtnEnable,
    currentPage,
    totalCount,
    finalSubmitReq,
    optionMarked,
    loading,
    language,
    handleOptionChange,
    translationData
}) => {
    const translations = translationData?.baseline || {};
    const renderQuestion = (data) => {

        return (
            <>

                <div className="textBox pb-1 pt-2 position-relative">
                    <div className="shareEmail3 ">

                        <div><p>{getText(data?.title, language)}</p></div>
                        {getText(data?.file_path, language) && <div className="d-flex justify-content-center">
                            <img src={getText(data?.file_path, language)} alt="quiz-img" style={{ maxHeight: "350px" }} />
                        </div>}
                        <form className="single-type pt-2">
                            <div className="row justify-content-center text-center">
                                {data?.options?.map((option, index) => (
                                    <label key={index}>
                                        <input
                                            type="radio"
                                            name="option"
                                            value={option}
                                            checked={Number(optionMarked.id) === Number(option.id) ? Number(optionMarked.id) === Number(option.id) : Number(selectedOptions.id) === Number(option.id)}
                                            onChange={() => handleOptionChange(option, index)}
                                        />
                                        <span style={{ textAlign: "start" }}>{getText(option.title, language)} </span>

                                    </label>
                                ))
                                }
                            </div>
                        </form>
                    </div>
                </div>

            </>
        )
    }
    return (
        <div className="container-fluid px-0 background-image">
            <div className="row justify-content-center">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-md-12">
                    <section className="my-3">
                        <div className="container-fluid">
                            <>
                                {renderQuestion(question?.baseline_question[0])}

                                <div className="row">
                                    <div className="col-12">
                                        <div className="mark-buttons d-flex justify-content-between " style={{ marginTop: 150, marginBottom: 100 }}>
                                            <div className="left-btn"> <button onClick={handlePreviousClick}
                                                disabled={Number(currentPage) === 1}
                                                className="previous_btn_baseline"
                                            >
                                                <FontAwesomeIcon icon={faArrowLeft} size="lg" color="#fff" />
                                            </button>

                                            </div>

                                            {Number(currentPage) === Number(totalCount) ? <div className="markButtons"> <button
                                                className="d-flex align-items-center gap-2"
                                                onClick={() => { finalSubmitReq() }}
                                                style={{ backgroundColor: nextBtnEnable === false ? "#c8c8c8" : Object.keys(selectedOptions).length === 0 ? "#c8c8c8" : loading ? "#c8c8c8" : "#792110", color: nextBtnEnable === false ? "#212529" : Object.keys(selectedOptions).length === 0 ? "#212529" : loading ? "#212529" : "#ffffff" }}
                                                disabled={nextBtnEnable === false ? true : Object.keys(selectedOptions).length === 0 ? true : loading ? true : false}
                                            >
                                                {getText(translations.submit, language)}

                                            </button>
                                            </div>
                                                : ""}
                                            <div className="right-btn">
                                                <button
                                                    type="button"
                                                    className="previous_btn_baseline"
                                                    onClick={handleNextClick}
                                                    disabled={
                                                        Number(currentPage) === Number(totalCount)
                                                            ? true
                                                            : !nextBtnEnable ||
                                                              Object.keys(selectedOptions).length === 0 ||
                                                              loading
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            Number(currentPage) === Number(totalCount)
                                                                ? "#c8c8c8"
                                                                : !nextBtnEnable ||
                                                                  Object.keys(selectedOptions).length === 0 ||
                                                                  loading
                                                                  ? "#c8c8c8"
                                                                  : "#792110",
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faArrowRight} size="lg" color="#fff" />
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>

                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default QuizQuestionSection